import { withViewModel } from '../../infrastructure/components/with-view-model';
import { JobType } from '../../api/jobs.dao';
import { JobsMonitorHostVM } from './jobs-monitor-host.viewmodel';
import { uploadThemeArchive } from './job-types/upload-theme-archive';
import { deleteEventJobProperties } from './job-types/delete-event';
import { eventBlueprintTriggerJobProperties } from './job-types/event-blueprint-trigger';
import { meetingBlueprintTriggerJobProperties } from './job-types/meeting-blueprint-trigger';

const JobsMonitorHost = withViewModel(
    // we don't need anything to be rendered for jobs monitor - we only need viewmodel to be operational while component is mounted
    () => null,
    () => {
        const jobsMonitorVM = new JobsMonitorHostVM(
            /**
             * Let's keep it handling JobExecutions which doesn't belong to any particular Event.
             */
            {
                [JobType.UploadPassportTheme]: uploadThemeArchive,
                [JobType.DeleteEvent]: deleteEventJobProperties,
                [JobType.UploadEmbeddedHTMLZip]: uploadThemeArchive,
                [JobType.EventBlueprintTrigger]: eventBlueprintTriggerJobProperties,
                [JobType.MeetingBlueprintTrigger]: meetingBlueprintTriggerJobProperties,
            }
        );
        jobsMonitorVM.initialize();
        return jobsMonitorVM;
    },
    null,
    vm => vm.cleanup()
);

export { JobsMonitorHost };
